import React from 'react'
import HeroBanner from '../../components/User/common/HeroBanner'
import StrategiesPage from '../../components/User/Home/StrategiesPag'

const Blog = () => {
  return (
    <div>
        <HeroBanner subheading='Home / Our Blogs'/>
        <StrategiesPage/>
    </div>
  )
}

export default Blog